<div class="comp-subscribe"
    [ngClass]="(versi == '1')?'versi-1':'versi-2'">
    <form #subsForm="ngForm" (ngSubmit)="onSubscribe(subsForm)">
        <div class="form-group d-flex"
            [ngClass]="{'flex-2 mb-0': versi == '2'}">
            <div class="label pr-2">
                <label for="subscribe" 
                    class="d-md-block d-none"
                     [ngClass]="{'mb-0': versi == '2'}">
                      {{ isLang?.subscribeNewsletter }} 
                </label>
                <!-- click modal mobile -->
                <label for="subscribe" 
                        (click)="showModal()"
                        class="d-md-none d-block"
                        [ngClass]="{'mb-0': versi == '2'}">
                        {{ isLang?.subscribeNewsletter }} 
                </label>
            </div>
            <div class="email d-flex">
                <input type="email" 
                        class="form-control" 
                        id="subs2"
                        email 
                        pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                        required
                        [class.is-invalid]="email.invalid && email.touched"
                        name="email" 
                        #email="ngModel"
                        ngModel
                        placeholder="{{ isLang?.insertEmail }}">
                <button class="btn submit"
                        type="submit"
                        [disabled]="subsForm.form.invalid">
                    <img src="../../../assets/images/icon/arrow-left.svg" alt="">
                </button>
            </div>
        </div>
    </form>
    <!-- mobile -->
    <div bsModal 
        *ngIf="isModalShown" 
        [config]="{ show: true }" 
        (onHidden)="onHidden()" 
        #modal="bs-modal" 
        class="modal fade modal-subscribe" 
        tabindex="-1" 
        role="dialog" 
        aria-labelledby="dialog-sizes-name2">
        <div class="modal-dialog d-flex align-items-center h-100 my-0 py-4">
            <div class="modal-content">
                <div class="modal-x" aria-label="Close" (click)="modal.hide()">
                    <span aria-hidden="true"><i class="icon ion-ios-close"></i></span>
                </div>
                <div class="flag">
                    <img src="../../../assets/images/icon/flag.svg" width="100%" alt="">
                </div>
                <div class="modal-body">
                    <div class="info">
                        <h6 class="tit-f18b">Subscribe Newsletter</h6>
                        <p class="mt-3 mb-4">{{ isLang?.subscribeInput }} </p>
                    </div>
                    <form #subsForm="ngForm" (ngSubmit)="onSubscribe(subsForm)" class="email d-flex">
                        <input type="email" 
                                class="form-control" 
                                id="subs1"
                                email 
                                pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,3}$"
                                required
                                [class.is-invalid]="email.invalid && email.touched"
                                name="email" 
                                #email="ngModel"
                                ngModel
                                placeholder="{{ isLang?.insertEmail }}">
                        <button [disabled]="subsForm.form.invalid"
                                class="btn submit" 
                                type="submit">
                            <img src="../../../assets/images/icon/arrow-left.svg" alt="">
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</div>
